// Shared GLSL. Aerial perspective per FOUNDATION §4.1: as an object recedes,
// (1) colour lerps toward the background, (2) chroma falls to zero AHEAD of the fog,
// (3) internal contrast collapses. Fog alone gives flat pale shapes; the desaturation
// term is what makes the white world read as air.
export const HASH = /* glsl */ `
vec3 hash31(float p) {
  vec3 p3 = fract(vec3(p) * vec3(0.1031, 0.1030, 0.0973));
  p3 += dot(p3, p3.yzx + 33.33);
  return fract((p3.xxy + p3.yzz) * p3.zyx);
}
float hash11(float p) {
  p = fract(p * 0.1031);
  p *= p + 33.33;
  p *= p + p;
  return fract(p);
}
`

export const AERIAL = /* glsl */ `
vec3 aerial(vec3 col, float dist, float density, vec3 bg) {
  float f = 1.0 - exp(-density * density * dist * dist);
  float g = clamp(f * 1.7, 0.0, 1.0);
  float lum = dot(col, vec3(0.299, 0.587, 0.114));
  col = mix(col, vec3(lum), g);
  col = mix(col, bg, f);
  return col;
}
`

// Typing taps for the ape models, in the ape's LOCAL space (grounded, unscaled:
// bbox y 0..1.9, front +z). Selects the hands/forearms region by position —
// forward of the torso, mid height — and presses it down in sharp alternating
// strokes (left/right split by x sign). Both the hero and the instanced field
// apes share this, phase-offset by seed.
export const TYPING = /* glsl */ `
vec3 typing(vec3 p, float t, float seed) {
  float w = smoothstep(0.45, 0.7, p.z)
          * smoothstep(0.35, 0.5, p.y)
          * smoothstep(0.95, 0.72, p.y);
  float side = step(0.0, p.x);
  float ph = t * (6.2 + fract(seed) * 1.6) + seed + side * 3.14159;
  p.y -= w * 0.03 * pow(max(sin(ph), 0.0), 3.0);
  return p;
}
`
